export const storage_url = "https://api.brandripplr.com/storage/v1/object/public/brandripplr/";
export const storage_url_render = "https://api.brandripplr.com/storage/v1/render/image/public/brandripplr/";
export function randomString() {
  const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890*&^%$#@!";
  const lengthOfCode = 20;
  let text = "";
  for (let i = 0; i < lengthOfCode; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}

export function getAllUrlParams(url) {
  // get query string from url (optional) or window
  let queryString = url ? url.split("#")[1] : window.location.search.slice(1);

  // we'll store the parameters here
  const obj = {};

  // if query string exists
  if (queryString) {
    // stuff after # is not part of query string, so get rid of it
    queryString = queryString.split("#")[0];

    // split our query string into its component parts
    const arr = queryString.split("&");

    for (let i = 0; i < arr.length; i++) {
      // separate the keys and the values
      const a = arr[i].split("=");

      // set parameter name and value (use 'true' if empty)
      let paramName = a[0];
      let paramValue = typeof a[1] === "undefined" ? true : a[1];

      // (optional) keep case consistent
      paramName = paramName.toLowerCase();
      if (typeof paramValue === "string") paramValue = paramValue.toLowerCase();

      // if the paramName ends with square brackets, e.g. colors[] or colors[2]
      if (paramName.match(/\[(\d+)?\]$/)) {
        // create key if it doesn't exist
        const key = paramName.replace(/\[(\d+)?\]/, "");
        if (!obj[key]) obj[key] = [];

        // if it's an indexed array e.g. colors[2]
        if (paramName.match(/\[\d+\]$/)) {
          // get the index value and add the entry at the appropriate position
          const index = /\[(\d+)\]/.exec(paramName);
          if (index) {
            obj[key][index[1]] = paramValue;
          }
        } else {
          // otherwise add the value to the end of the array
          obj[key].push(paramValue);
        }
      } else {
        // we're dealing with a string
        if (!obj[paramName]) {
          // if it doesn't exist, create property
          obj[paramName] = paramValue;
        } else if (obj[paramName] && typeof obj[paramName] === "string") {
          // if property does exist and it's a string, convert it to an array
          obj[paramName] = [obj[paramName]];
          obj[paramName].push(paramValue);
        } else {
          obj[paramName].push(paramValue);
        }
      }
    }
  }

  return obj;
}

export const getPagination = (page, size) => {
  const limit = size ? +size : 3
  const from = page ? page * limit : 0
  const to = page ? from + size - 1 : size - 1

  return { from, to }
}

export function getSocialLink(network) {
  if (network.type) {
    network.social_network = network.type;
  }
  if (network.social_network == "youtube" && network.social_network_id) {
    return `https://www.youtube.com/channel/${network.social_network_id}`;
  } else if (network.social_network == "youtube" && network.username) {
    return `https://www.youtube.com/@${network.username}`;
  } else if (network.social_network == "instagram" && network.username) {
    return `https://www.instagram.com/${network.username}`;
  } else if (network.social_network == "facebook" && network.username) {
    return `https://www.facebook.com/${network.username}`;
  } else if (network.social_network == "twitter" && network.username) {
    return `https://www.twitter.com/${network.username}`;
  } else if (network.social_network == "tiktok" && network.username) {
    return `https://www.tiktok.com/@${network.username}`;
  } else if (network.social_network == "twitch" && network.username) {
    return `https://www.twitch.tv/${network.username}`;
  } else if (network.social_network == "snapchat" && network.username) {
    return `https://www.snapchat.com/add/${network.username}`;
  }
  return null
}

const YOUTUBE_RESERVED_PATHS = new Set([
  "watch",
  "playlist",
  "results",
  "feed",
  "shorts",
  "live",
  "gaming",
  "topic",
]);

function parseYoutubeSegments(segments = []) {
  const identifiers = { channelId: "", username: "" };
  if (!segments.length) {
    return identifiers;
  }

  const [firstRaw, secondRaw] = segments;
  const first = firstRaw?.toLowerCase?.() || "";
  const second = secondRaw || "";

  if (first === "channel" && second) {
    identifiers.channelId = second;
    return identifiers;
  }

  if ((first === "user" || first === "c") && second) {
    identifiers.username = second;
    return identifiers;
  }

  if (firstRaw && firstRaw.startsWith("@")) {
    identifiers.username = firstRaw.slice(1);
    return identifiers;
  }

  if (!YOUTUBE_RESERVED_PATHS.has(first) && first) {
    identifiers.username = firstRaw;
  }

  return identifiers;
}

export function parseYoutubeChannelUrl(rawUrl) {
  const identifiers = { channelId: "", username: "" };
  if (!rawUrl || typeof rawUrl !== "string") {
    return identifiers;
  }

  const trimmed = rawUrl.trim();
  if (!trimmed) {
    return identifiers;
  }

  const ensureUrl = (value) => {
    if (/^https?:\/\//i.test(value)) {
      return value;
    }
    return `https://${value}`;
  };

  let segments = [];
  try {
    const url = new URL(ensureUrl(trimmed));
    segments = url.pathname.split("/").filter(Boolean);
  } catch (_err) {
    const fallback = trimmed.replace(/^https?:\/\//i, "");
    segments = fallback.split("/").filter(Boolean);
  }

  const parsed = parseYoutubeSegments(segments);
  if (!parsed.channelId && !parsed.username && segments.length > 1) {
    // Try again without trailing modifiers such as 'featured'
    const truncated = segments.slice(0, 2);
    return parseYoutubeSegments(truncated);
  }
  return parsed;
}

export function parseYoutubeVideoId(rawUrl) {
  if (!rawUrl || typeof rawUrl !== "string") {
    return "";
  }

  const trimmed = rawUrl.trim();
  if (!trimmed) return "";

  const normalizeUrl = (value) => {
    if (/^https?:\/\//i.test(value)) return value;
    return `https://${value}`;
  };

  const extractFromSegments = (segments = []) => {
    if (!segments.length) return "";
    if (segments[0] === "shorts" && segments[1]) return segments[1];
    if (segments[0] === "embed" && segments[1]) return segments[1];
    if (segments[0] === "live" && segments[1]) return segments[1];
    if (segments.length === 1) return segments[0];
    return "";
  };

  try {
    const url = new URL(normalizeUrl(trimmed));
    const hostname = url.hostname.replace(/^www\./i, "");
    const segments = url.pathname.split("/").filter(Boolean);

    if (hostname === "youtu.be") {
      return segments[0] || "";
    }

    if (hostname.includes("youtube.")) {
      const vParam = url.searchParams.get("v");
      if (vParam) return vParam;
      const viParam = url.searchParams.get("vi");
      if (viParam) return viParam;
      const fromSegments = extractFromSegments(segments);
      if (fromSegments) return fromSegments;
    }
  } catch (_err) {
    // Fallback to regex parsing for non-standard URLs
  }

  const fallbackMatch = trimmed.match(
    /(?:v=|vi=|youtu\.be\/|\/embed\/|\/shorts\/)([A-Za-z0-9_-]{6,})/
  );
  return fallbackMatch ? fallbackMatch[1] : "";
}

export function formatNumber(number) {
  const hasDecimal = number % 1 !== 0; // check if there's a fractional part
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: hasDecimal ? 2 : 0,
    maximumFractionDigits: hasDecimal ? 2 : 0,
  }).format(number);
}

export function intlNumberFormat(number) {
  return new Intl.NumberFormat('en-US', {
    notation: "compact",
    roundingMode: "floor",
    maximumFractionDigits: 2
  }).format(number);
}

// Cost metrics (CPV / CPI / CPE / ROI) are often well under $1 - a CPV of
// 0.003 formatted with intlNumberFormat (floor, max 2 fraction digits)
// renders as "0". Below $1 we switch to significant digits so small values
// stay readable; at $1 and above behaviour is identical to intlNumberFormat.
export function intlCostFormat(number) {
  const value = Number(number);
  if (!isFinite(value) || value === 0) return "0";
  if (Math.abs(value) < 1) {
    return new Intl.NumberFormat('en-US', {
      maximumSignificantDigits: 3
    }).format(value);
  }
  return new Intl.NumberFormat('en-US', {
    notation: "compact",
    roundingMode: "floor",
    maximumFractionDigits: 2
  }).format(value);
}

// Tax handling (2026-08-10): an invitation carries EITHER vat OR wht
// (invitation.wht != null means WHT mode; vat is stored as 0 there).
// VAT adds on top: fee * (1 + vat/100). WHT grosses up so the talent still
// nets `fee` after withholding: fee / (1 - wht/100). Pass invitation.wht as
// the optional wht argument — omitted/null falls back to the VAT math.
export function influencerFeeWithVat(fee, vat, wht) {
  if (wht != null) return fee / (1 - Math.min(wht, 99) / 100);
  return fee + (fee * vat / 100);
}
// `model` is the campaign's finance_model (see FINANCE_MODEL below). Omitted
// or 'v1' keeps the original maths exactly: BR is a margin on the client price,
// fee ÷ (1 − BR%). 'v2' makes BR a markup on the fee: fee × (1 + BR%).
export function influencerFeeWithBR(fee, vat, br, wht, model) {
  let fee_with_vat = influencerFeeWithVat(fee, vat, wht);
  return Math.round(applyBr(fee_with_vat, br, model) * 100) / 100;
}
export function influencerFeeWithBRExcel(fee, vat, br, wht, model) {
  let fee_with_vat = influencerFeeWithVat(fee, vat, wht);
  let fee_with_br = Math.round(applyBr(fee_with_vat, br, model) * 100) / 100;
  // if fee_with_br 16502 or 16502.2 make it 16510 thats an example of rounding some times price will be 625.25 or 625 make it 630
  if (fee_with_br % 5 === 0) return fee_with_br;
  // Otherwise, round up to the next 10
  return Math.ceil(fee_with_br / 5) * 5;

}
export function influencerFeeRemoveVat(fee, vat) {
  const round2 = (num) => Math.round(num * 100) / 100;
  const base = round2(fee / (1 + vat / 100));
  const vatAmount = round2(fee - base);
  return { base, vatAmount };
}
export function displayUsername(value) {
  if (!value) return "";
  try {
    return decodeURIComponent(value);
  } catch (_) {
    return value;
  }
}

export function statusSeverity(status) {
  if (status == "accepted" || status == "completed") {
    return "success";
  } else if (status == "pending-client-approval") {
    return "warning";
  } else if (
    status == "client-rejected" ||
    status == "rejected" ||
    status == "cancelled"
  ) {
    return "danger";
  } else {
    return "info";
  }
}

export function getFileExtension(url) {
  // last .
  const lastDotIndex = url.lastIndexOf(".");
  return url.substring(lastDotIndex + 1);
}

const proxyUrl = "https://api.brandripplr.com/functions/v1/image-proxy?url=";

export function imageProxyUrl(imageUrl) {
  // contain static.brandripplr.com
  if (imageUrl.includes("static.brandripplr.com")) {
    const response = proxyUrl + encodeURIComponent(imageUrl);
    return response;
  }
  return imageUrl;
}

export function getStoryLink(type, post) {
  if (type == 'story') {
    return window.location.origin + '/campaign/post/' + post.id;
  }
  return post.link;
}

export const quillModule = {
  toolbar: [
    [{ 'size': [false] }],
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    [{ 'header': [1, 2, 3, false] }],                       // text direction

    ['link'],
    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
  ],
  history: {
    delay: 2000,
    maxStack: 500,
    userOnly: true
  },
}
export const quillModuleWithImage = {
  toolbar: [
    [{ 'size': [false] }],
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    [{ 'header': [1, 2, 3, false] }],                       // text direction

    ['link'],
    ['image'],
    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
  ],
  history: {
    delay: 2000,
    maxStack: 500,
    userOnly: true
  },
}

// What PM % is struck on — campaign.pm_margin_basis.
//   campaign_fee   : PM is a share OF the fee        -> base * pm%
//   influencer_fee : PM is a markup ON what is left  -> base - base / (1 + pm%)
// e.g. 20,000 @ 20%: campaign_fee leaves 16,000 (PM 4,000); influencer_fee
// leaves 16,666.67 (PM 3,333.33, which is 20% of 16,666.67).
export const PM_MARGIN_BASIS = {
  CAMPAIGN_FEE: "campaign_fee",
  INFLUENCER_FEE: "influencer_fee",
};

export const pmMarginBasisOptions = [
  { label: "Campaign Fee", value: PM_MARGIN_BASIS.CAMPAIGN_FEE },
  { label: "Influencer Fee", value: PM_MARGIN_BASIS.INFLUENCER_FEE },
];

// anything unknown / missing (older rows, column not loaded) is Campaign Fee
export function normalizePmMarginBasis(basis) {
  return basis === PM_MARGIN_BASIS.INFLUENCER_FEE
    ? PM_MARGIN_BASIS.INFLUENCER_FEE
    : PM_MARGIN_BASIS.CAMPAIGN_FEE;
}

/**
 * PM amount BEFORE its credit note, struck on `base` (fee less CS fee).
 * Mirrored in SQL by the finance_forecast_all and finance_campaign views —
 * change one, change the others.
 */
export function pmGrossAmount(base, pm, basis) {
  if (normalizePmMarginBasis(basis) === PM_MARGIN_BASIS.INFLUENCER_FEE) {
    return base - base / (1 + pm / 100);
  }
  return (base * pm) / 100;
}

/**
 * PM rate actually charged once the PM credit note is netted, measured the
 * same way the nominal rate is: against the base for campaign_fee, against
 * what is left after PM for influencer_fee. With no credit it equals pm %.
 */
export function pmEffectiveRate(base, pmAmount, basis) {
  if (normalizePmMarginBasis(basis) === PM_MARGIN_BASIS.INFLUENCER_FEE) {
    const rest = base - pmAmount;
    return rest ? (pmAmount / rest) * 100 : 0;
  }
  return base ? (pmAmount / base) * 100 : 0;
}

/**
 * Single source of truth for a campaign's finance breakdown.
 *
 * Both the campaign Finance tab and the Management sidebar render figures from
 * this, so the two can't drift — they previously each held their own copy of
 * the maths and disagreed once credit notes were split by source.
 *
 * Every credit note nets against the line it is funded from:
 *   Creative Strategy / PM / Logistics reduce their own deduction, so the money
 *   stays in the pot; BR and Influencer Fee are taken after the BR split, so
 *   that money leaves the campaign.
 *
 * Accepts a campaign row or the Finance tab's form object — same field names.
 */
export function campaignFinanceParts(campaign) {
  const n = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);
  const c = campaign || {};

  const fee = n(c.fee);
  const pm = n(c.pm_percentage);
  const pmBasis = normalizePmMarginBasis(c.pm_margin_basis);
  const br = n(c.br_commission);

  const csCredit = n(c.credit_note_creative_strategy);
  const logisticsCredit = n(c.credit_note_logistics);
  const pmCredit = n(c.credit_note_pm);
  const brCredit = n(c.credit_note_br);
  const creditInfluencerFee = n(c.credit_note_influencer_fee);

  // net-of-credit values for each line
  const cs = n(c.cs_fee) - csCredit;
  const logistics = n(c.logistics_budget) - logisticsCredit;

  const afterCsFee = fee - cs;
  const pmAmount = pmGrossAmount(afterCsFee, pm, pmBasis) - pmCredit;
  const influencerBudget = afterCsFee - pmAmount - logistics;

  // BR share and the talent's share are BOTH struck on the original BR %,
  // then each takes its own credit note — so they no longer add back to the
  // influencer budget; the credited money has left it.
  const brShare = (influencerBudget * br) / 100 - brCredit;
  const netToTalent = influencerBudget * (1 - br / 100) - creditInfluencerFee;
  const influencerBudgetAfterCredit = influencerBudget - brCredit - creditInfluencerFee;

  return {
    fee,
    pm,
    pmBasis,
    br,
    cs,
    csCredit,
    logistics,
    logisticsCredit,
    pmAmount,
    pmCredit,
    brCredit,
    creditInfluencerFee,
    afterCsFee,
    influencerBudget,
    influencerBudgetAfterCredit,
    brShare,
    netToTalent,
    // effective rates once credits are applied
    pmEffective: pmEffectiveRate(afterCsFee, pmAmount, pmBasis),
    brEffective: influencerBudgetAfterCredit
      ? (brShare / influencerBudgetAfterCredit) * 100
      : 0,
  };
}

// ---------------------------------------------------------------------------
// Finance formula version — campaign.finance_model.
//
//   v1 : the original maths above (campaignFinanceParts). The Campaign Budget
//        is everything the client pays; Additional Services, PM and Logistics
//        come out of it, and BR is a share of what is left.
//   v2 : the Campaign Finance Dashboard (Tanaz, Oct 2026). The Campaign Budget
//        is influencer fees + PM + BR only. PM and BR are markups, Logistics
//        (+ an Operations Margin) and Additional Services are added on top,
//        and each credit note only reduces its own line.
//
// Every existing campaign is v1 and keeps its figures. v2 is switched on per
// campaign (Finance tab, financeModelSwitchUserIds) until testing is finished; then
// the column default becomes 'v2' so only NEW campaigns get it.
// Mirrored in SQL by finance_forecast_all / finance_campaign /
// influencer_client_fee() — change one, change the others.
// ---------------------------------------------------------------------------
export const FINANCE_MODEL = { V1: "v1", V2: "v2" };

export const financeModelOptions = [
  { label: "Current formula", value: FINANCE_MODEL.V1 },
  { label: "New formula", value: FINANCE_MODEL.V2 },
];

export function normalizeFinanceModel(model) {
  return model === FINANCE_MODEL.V2 ? FINANCE_MODEL.V2 : FINANCE_MODEL.V1;
}

// accepts a campaign row, a form object or a bare model string
export function isFinanceV2(campaignOrModel) {
  const model =
    campaignOrModel && typeof campaignOrModel === "object"
      ? campaignOrModel.finance_model
      : campaignOrModel;
  return normalizeFinanceModel(model) === FINANCE_MODEL.V2;
}

// BR on one influencer's price (amount already includes VAT / the WHT gross-up)
//   v1 : margin on the client price  amount ÷ (1 − BR%)   1,000 @ 15% → 1,176.47
//   v2 : markup on the fee           amount × (1 + BR%)   1,000 @ 15% → 1,150.00
export function applyBr(amount, br, model) {
  if (isFinanceV2(model)) return amount * (1 + (Number(br) || 0) / 100);
  return amount / (1 - (br / 100));
}

// finance_model for one invitation: the open campaign's live value when the
// invitation belongs to it (so a just-switched formula applies at once),
// otherwise the campaign embedded on the invitation row, otherwise v1.
export function invitationFinanceModel(invitation, openCampaign) {
  const inv = invitation || {};
  const open = openCampaign || {};
  if (open.finance_model && (inv.campaign_id == null || inv.campaign_id == open.id)) {
    return normalizeFinanceModel(open.finance_model);
  }
  if (inv.campaign && inv.campaign.finance_model) {
    return normalizeFinanceModel(inv.campaign.finance_model);
  }
  return FINANCE_MODEL.V1;
}

// Invitation statuses whose fee counts as influencer spend (v2 Target vs
// Actual, client-version check): from client approval onwards. The SQL
// finance_campaign.influencer_actual_spend uses the same list.
export const INFLUENCER_SPEND_STATUSES = [
  "pending-client-approval",
  "pending",
  "accepted",
  "completed",
];

// One talent's fee including tax: + VAT, or grossed up for WHT — the same
// figure influencerFeeWithVat() gives, safe on missing values. Mirrored in SQL
// by public.invitation_fee_incl_tax().
export function invitationFeeInclTax(inv) {
  const fee = Number(inv && inv.fee);
  if (!Number.isFinite(fee)) return 0;
  const wht = inv.wht === null || inv.wht === undefined || inv.wht === "" ? null : Number(inv.wht);
  return influencerFeeWithVat(fee, Number(inv.vat) || 0, Number.isFinite(wht) ? wht : null);
}

// BR earned on the actual influencer spend: each talent's fee incl. VAT/WHT ×
// their BR %.
export function influencerActualBr(invitations) {
  return (invitations || []).reduce((sum, inv) => {
    if (!inv || !INFLUENCER_SPEND_STATUSES.includes(inv.status)) return sum;
    const br = Number(inv.br_commission);
    return Number.isFinite(br) ? sum + (invitationFeeInclTax(inv) * br) / 100 : sum;
  }, 0);
}

// Σ "Influencer fee incl BR" as the influencer cards show it (new formula:
// fee incl. VAT/WHT × (1 + BR%), rounded per influencer like the card).
export function influencerSpendInclBr(invitations) {
  return (invitations || []).reduce((sum, inv) => {
    if (!inv || !INFLUENCER_SPEND_STATUSES.includes(inv.status)) return sum;
    const fee = Number(inv.fee);
    if (!Number.isFinite(fee)) return sum;
    const wht = inv.wht === null || inv.wht === undefined || inv.wht === "" ? null : Number(inv.wht);
    return sum + influencerFeeWithBR(fee, Number(inv.vat) || 0, Number(inv.br_commission) || 0, Number.isFinite(wht) ? wht : null, FINANCE_MODEL.V2);
  }, 0);
}

// Actual influencer spend = fees incl. VAT / WHT, no BR.
export function influencerActualSpend(invitations) {
  return (invitations || []).reduce((sum, inv) => {
    if (!inv || !INFLUENCER_SPEND_STATUSES.includes(inv.status)) return sum;
    return sum + invitationFeeInclTax(inv);
  }, 0);
}

// Backwards budget (no client budget, campaign.budget_from_influencers): the
// influencers counted — the same as influencer spend, Pending Client Approval
// onwards (Ahmer, 2 Nov 2026), so the budget equals the sum of the
// influencers' "fee incl BR" shown on their cards. Mirrored in SQL by
// public.campaign_backwards_totals().
export const BACKWARDS_BUDGET_STATUSES = INFLUENCER_SPEND_STATUSES;

// cost        Σ fee incl. VAT / WHT            → the Influencer Spend Budget
// costWithBr  Σ fee incl. VAT / WHT × (1 + BR%) (each talent's own BR %)
// The campaign budget is costWithBr × (1 + PM%). Mirrored in SQL by
// public.campaign_backwards_totals(), which keeps campaign.fee up to date.
export function backwardsInfluencerTotals(invitations) {
  return (invitations || []).reduce(
    (t, inv) => {
      if (!inv || !BACKWARDS_BUDGET_STATUSES.includes(inv.status)) return t;
      const gross = invitationFeeInclTax(inv);
      const br = Number(inv.br_commission) || 0;
      return { cost: t.cost + gross, costWithBr: t.costWithBr + gross * (1 + br / 100) };
    },
    { cost: 0, costWithBr: 0 }
  );
}

/**
 * v2 campaign breakdown — the Campaign Finance Dashboard sheet, section by
 * section. Accepts a campaign row or the Finance tab form (same field names):
 *   fee                          Total Campaign Budget (influencers + PM + BR)
 *   pm_percentage / br_commission
 *   logistics_budget             Logistics & Operations Budget (before margin)
 *   logistics_percentage         Operations Margin %
 *   cs_fee                       Additional Services (at cost, no margin)
 *   credit_note_pm / _br / _influencer_fee / _logistics /
 *   _operations_margin / _creative_strategy (Additional Services)
 *
 * Sheet example: 30,000 @ PM 10% / BR 15%, logistics 5,000 @ 15%, services
 * 2,000 → PM 2,727, BR 3,557, spend 23,715, ops margin 882, net total 37,882.
 */
export function campaignFinanceV2(campaign) {
  const n = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);
  const c = campaign || {};

  const total = n(c.fee);
  const pm = n(c.pm_percentage);
  const br = n(c.br_commission);
  // capped below 100 so the gross-up can never divide by zero
  const opsPct = Math.min(Math.max(n(c.logistics_percentage), 0), 99);

  // 2. Campaign Budget Breakdown — PM and BR are both grossed out of the total.
  // A backwards budget (built up from the influencers) takes the spend from
  // the influencers themselves, so the split reconciles even when they carry
  // different BR %s: BR is whatever sits between that and the after-PM figure.
  const backwards = !!c.budget_from_influencers;
  const afterPm = total / (1 + pm / 100);
  const pmFee = total - afterPm;
  const spend = backwards ? n(c.backwards_influencer_cost) : afterPm / (1 + br / 100);
  const brFee = afterPm - spend;

  // 3. Other Costs — on top of the campaign budget
  const logistics = n(c.logistics_budget);
  const opsMargin = logistics / (1 - opsPct / 100) - logistics;
  const additional = n(c.cs_fee);

  // 4. Credit notes — each reduces only its own line
  const line = (budget, credit) => ({ budget, credit, final: budget - credit });
  const lines = {
    pm: line(pmFee, n(c.credit_note_pm)),
    br: line(brFee, n(c.credit_note_br)),
    influencer: line(spend, n(c.credit_note_influencer_fee)),
    logistics: line(logistics, n(c.credit_note_logistics)),
    opsMargin: line(opsMargin, n(c.credit_note_operations_margin)),
    additional: line(additional, n(c.credit_note_creative_strategy)),
  };
  const sum = (keys, k) => keys.reduce((a, key) => a + lines[key][k], 0);
  const group = (keys, budget) => {
    const credit = sum(keys, "credit");
    return { budget, credit, final: budget - credit };
  };
  const campaignTotal = group(["pm", "br", "influencer"], total);
  const otherCosts = group(
    ["logistics", "opsMargin", "additional"],
    logistics + opsMargin + additional
  );
  const netTotal = {
    budget: campaignTotal.budget + otherCosts.budget,
    credit: campaignTotal.credit + otherCosts.credit,
    final: campaignTotal.final + otherCosts.final,
  };

  // Brandripplr's planned margin: Additional Services + PM + BR + operations
  // margin, after credit notes — the Forecasting Total BR Margin (before
  // agency), same as Creative Strategy counts on the current formula.
  const margin =
    lines.additional.final + lines.pm.final + lines.br.final + lines.opsMargin.final;

  return {
    total,
    backwards,
    pm,
    br,
    opsPct,
    afterPm,
    pmFee,
    brFee,
    spend,
    logistics,
    opsMargin,
    additional,
    lines,
    campaignTotal,
    otherCosts,
    netTotal,
    // the v2 equivalent of v1's "Influencer Budget after Credit Note" (incl. BR)
    influencerBudgetInclBr: lines.influencer.final + lines.br.final,
    margin,
    marginPercentage: netTotal.budget ? (margin / netTotal.budget) * 100 : 0,
  };
}

/**
 * 5. Target vs. Actual. `actual` values may be null (not entered yet):
 *   influencer  fees incl. VAT / WHT, no BR — from the database
 *   br          BR earned on that spend (fee × BR% per talent), used for the
 *               BR % line: the campaign's BR % (target) against the BR % set
 *               on the influencers, weighted by fee (actual)
 *   logistics / additional  entered actual spend; until one is entered it
 *               counts as its target (Nadine, Oct 2026)
 * A row with no actual spend shows no saving / overspend yet, and neither do
 * the totals until something real (spend or an entered actual) exists.
 *   state: 'none' (no actual yet) | 'saving' | 'even' | 'over'
 */
export function financeBudgetVsActual(parts, actual) {
  const a = actual || {};
  const entered = (v) => v !== null && v !== undefined && v !== "";
  const stateOf = (remaining, hasActual) => {
    const r2 = Math.round(remaining * 100) / 100;
    return !hasActual ? "none" : r2 > 0 ? "saving" : r2 < 0 ? "over" : "even";
  };
  const row = (key, label, budget, actualValue, defaultsToTarget) => {
    const isDefault = defaultsToTarget && !entered(actualValue);
    const spent = isDefault ? budget : Number(actualValue) || 0;
    const remaining = budget - spent;
    const hasActual = spent !== 0;
    return {
      key,
      label,
      budget,
      actual: spent,
      isDefault,
      remaining,
      percentage: hasActual && budget ? (remaining / budget) * 100 : null,
      state: stateOf(remaining, hasActual),
    };
  };
  const rows = [
    row("influencer", "Influencer Cost Tracking", parts.lines.influencer.final, a.influencer, false),
    row("logistics", "Logistics & Operations Cost Tracking", parts.lines.logistics.final, a.logistics, true),
    row("additional", "Additional Services Cost Tracking", parts.lines.additional.final, a.additional, true),
  ];
  const total = rows.reduce(
    (t, r) => ({ budget: t.budget + r.budget, actual: t.actual + r.actual }),
    { budget: 0, actual: 0 }
  );
  const remaining = total.budget - total.actual;
  // targets standing in for missing actuals don't count as "spend yet"
  const anyReal = rows.some((r) => !r.isDefault && r.actual !== 0);
  // BR %: target is the campaign's BR % as set; actual is the BR earned on
  // the talents ÷ their fees without BR (incl. VAT/WHT), so a talent set to
  // 15% shows exactly 15% (Ahmer, 29 Oct 2026, option A). BR earned = the sum
  // of their "Influencer fee incl BR" (as on each card) − their fees.
  // Percentages, so a line of its own outside the money totals.
  // e.g. 4921: BR 12,454.02 ÷ fees 76,009.23 = 16.38% vs 15% → (9.23%).
  const spend = Number(a.influencer) || 0;
  const campaignBr = Number(parts.br) || 0;
  const feesInclBr = entered(a.spendInclBr) ? Number(a.spendInclBr) || 0 : spend + (Number(a.br) || 0);
  const brEarned = feesInclBr - spend;
  const brTarget = campaignBr;
  const brActual = spend ? (brEarned / spend) * 100 : null;
  const brRemaining = brActual === null ? null : brTarget - brActual;
  // BR is margin, so the colours run the other way round from the cost rows:
  // BR below the campaign's rate is a loss (red, in brackets), above it a
  // gain (green) (Ahmer, 2 Nov 2026).
  const brGain = brActual === null ? null : brActual - brTarget;
  const brRate = {
    campaignBr,
    target: brTarget,
    actual: brActual,
    remaining: brRemaining,
    percentage: brActual !== null && brTarget ? (brGain / brTarget) * 100 : null,
    state: brActual === null ? "none" : stateOf(brGain, true),
  };
  return {
    rows,
    brRate,
    total: {
      ...total,
      remaining,
      percentage: anyReal && total.budget ? (remaining / total.budget) * 100 : null,
      state: stateOf(remaining, anyReal),
    },
  };
}

// Client version may only be shared once influencer spend incl. BR has
// reached the influencer budget incl. BR (Influencer Spend Budget + BR fee,
// after credit notes) — sharing it earlier would hand the savings back to the
// client. Both sides include BR, as the client version's fees do.
export function clientVersionBlocked(parts, spendInclBr) {
  const budget = Math.round(parts.influencerBudgetInclBr * 100) / 100;
  const spent = Math.round((Number(spendInclBr) || 0) * 100) / 100;
  return spent < budget;
}

// Talent Rationale is client-facing (shown on the review link), so an
// invitation can't go to Pending Client Approval without a real one.
// "BuzzBee", "UGC", "Stories" etc. don't count. Keep in sync with the
// invitation_require_talent_rationale DB trigger.
export const TALENT_RATIONALE_MIN_CHARS = 50;
export function talentRationaleText(html) {
  return String(html || "")
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/&[a-z#0-9]+;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
}
export function hasTalentRationale(html) {
  return talentRationaleText(html).length >= TALENT_RATIONALE_MIN_CHARS;
}
export const TALENT_RATIONALE_REQUIRED_MESSAGE =
  "Add a Talent Rationale (why this creator, for this brief) before sending to client approval. The client sees it on the review link.";
